package org.multiplatform.kotfolio.pages.kids.ride_to_read.class_2

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/kids/ride_to_read/class_2/mason")
@Composable
fun MasonPage() {
    BlogLayout(
        PageProperties(
            "Mason",
            ""
        ),
        BlogProperties("Ride To Reader", "Mason")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Let Us Read",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah was a ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "skilled mason.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold).color(Colors.Red)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He had been working as a mason for many years but he never had a house of his own. He was growing old and did not want to work anymore. He just wanted to live a ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "leisurely",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold).color(Colors.Red)
                    )

                    SpanText(
                        text = " life with his wife and children in a house of his own.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "So, one day, Abdullah told his ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "employer",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold).color(Colors.Red)
                    )

                    SpanText(
                        text = " employer, Junaid, that he wanted to ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "retire",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold).color(Colors.Red)
                    )

                    SpanText(
                        text = " Junaid was sad to lose a skilled employee like Abdullah.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He requested Abdullah to help him for the last time by building just one more house. Abdullah did not want to work, but Junaid insisted.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah finally agreed ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    SpanText(
                        text = "half heartedly.",
                        modifier = Modifier.fontSize(FontSize.Medium).fontWeight(FontWeight.Bold).color(Colors.Red)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah started to build the last house for Junaid. However, by then he was bored. So, he did not put much effort and even used poor-quality materials to build the house. He quickly completed building the house. Then, he called Junaid.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid came to meet Abdullah and handed over house papers and keys to him. \"I got this house made for you as my parting gift. You have been the best (Finest) mason. No one could have made a better house than you.\" Abdullah hung his head. He was ashamed (શરમિંદા) because he had not done a good job on the house. If he had known that he was building his own house, he would have made it better than any other house he had ever built.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "That is why we must always do our work well so that we don't have to be sorry later.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Meaning",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "skilled: expert at one's work",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mason: Someone who lays bricks for a building",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leisurely (LEE-zher-lee): Relaxed",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Retire: To stop working",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Half heartedly (Unwillingly): Without any interest",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Parting (Farewell): Leaving (Separating, Separating or saying goodbye)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Employer : A person who hires people to do some work",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Employer: One who gives a job",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Insisted (Insisted): Demanded firmly",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Hard Words",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Skillful, Mason, Leisurely, Employer, Retire, Employee, Requested, Insisted, Construction, Effort, Material, Workmanship, Parting, Ashamed (શરમિંદા)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Language Lane",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "cobbler - shoes",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "mason - bricks",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "tailor - cloth",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "carpenter - wood",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "electrician - wires",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Being verbs",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "'am, is, are' show the state of being in the present time.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The weather ________________ pleasant today. is",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Tina and Rima ________________ in London now. are",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "I ________________ eight years old. an",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The soup ________________ very tasty. is",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The flowers ________________ in the vase. are",
                                modifier = Modifier.fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "'was, were' show the state of being in the past time.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "My friends ________________ happy to see me. were",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Mr Singh ________________ a policeman. was",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Amit ________________ hungry so he ate a sandwich. was",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We ________________ in the park this morning. were",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "My mother ________________ busy in the garden. was",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Number the sentences in the correct order.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[2] Abdullah wanted to retire, but Junaid asked him to build one more house.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[4] When the house was completed, Junaid gave Abdullah the keys to the house.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[1] Abdullah was a skilled mason and Junaid was his employer.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[5] Abdullah was ashamed because he had not done a good job on the house.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "[3] Abdullah had lost all interest in his job. So, he did not put much effort to build the house.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Answer the following questions in 1-2 sentences each.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Although Abdullah worked as a mason for many years, what did he not have?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "He did not hare a house of his own.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "What did Junaid ask Abdullah to do once for the last time?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Junaid and Abdullah to build one more house.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Why did Junaid ask Abdullah to build a house?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Junaid wanted to give the house to Abdullah as a parting gift.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "What did Abdullah want to do after retiring?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "After getting retired Abdullah wanted to live a leisurely life with his wife and children in a house of his own.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Correct choose",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah was a skilled ________________ (carpenter, mason)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid was Abdullah's ________________ (friend, employer)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid was ________________ to lose an employee like Abdullah. (sad, angry)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid handed over ______ and ______ to  Abdullah. (house papers, keys)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "\"I got this house made for you as my parting gift. You have been the best mason. No one could have made a better house than you.\" Abdullah hung his head.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "Fill in the blanks with appropriate words with the silent 'u.",
                    modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                )

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Who said these words to whom? Junaid said Abdullah",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Which sentence tells us that Abdullah was ashamed? ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Why was Abdullah ashamed? Did not build a good house.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Write a another word for the word 'gift. Present",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Fill in the blanks with appropriate words with the silent 'u.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "My mother bakes the best chocolate ________________",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Helpful people on the street ________________ her back home.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The security ________________ stopped the stranger from entering.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ next to my house is a shopping mall.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This summer break, 1 plan to learn playing the ________________",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "I ________________ he's late.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This bag is not transparent, it is ________________",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Worksheet - 1",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Write ‘T’ if the statement is true and write ‘F’ if the statement is false.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah worked as a mason for 5 years. – False ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "He was going out of town, that’s why he did not want to work. – False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah planned to retire and live a leisurely life. – True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid was sad to lose a skillful employee like Abdullah. – True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid gifted the house as a parting gift to Abdullah. – True",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah used good quality material to build the house. – False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid was a selfish man. – False",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Junaid was Abdullah’s employee. – False ",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Complete the sentences",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah built the last house _________. without interest.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Abdullah was surprised when Junaid handed over the _________ to him. papers and keys",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = " If Abdullah knew it was his own house, he would have made it _________. better than any other house he ever built.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Short Answer Questions",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Who was Abdullah?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah was a skillful mason.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What did Junaid ask Abdullah to do?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Junaid asked Abdullah to build one last house for him.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How did Abdullah build the house?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah did not put much effort and even used poor quality materials to built the house. ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Abdullah hung his head?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah was ashamed as he did not built a good house.  ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Abdullah want to live a leisurely life with his wife and children? ",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah wanted to live a leisurely life with his wife and children because he was growing old now and he did not want to work anymore.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Junaid ask Abdullah to build the house for the last time?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Junaid forced Abdullah to help him build the house for the last time because he wanted to gift the same house as a parting gift to Abdullah.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why did Abdullah feel ashamed for not doing a great job?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah felt ashamed for not doing a great job because he did not care to put much effort in building the house which was later gifted to him by Junaid.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                                .padding(bottom = 0.2.em)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why Abdullah was retire?",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )

                        SpanText(
                            text = "Abdullah retired because he was growing old and did not want to work anymore. He wanted to spend a peaceful, leisurely life with his wife and children in a house of his own.",
                            modifier = Modifier.fontSize(FontSize.Medium).padding(bottom = 0.2.em)
                        )
                    }
                }
            }
        }
    }
}